export default __webpack_public_path__ + "static/media/Admitidos_Informática2023_24.0af84050.pdf";